// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.market.marketpage.handler.RentalGrowthTopRentalMarketsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetTopRentalMarketsRequestDto, GetTopRentalMarketsResponseDto } from '../..';

export const RentalGrowthTopRentalMarketsWebApiHandler_topMarkets_Path = '/api/web/v1/marketTrends/topMarkets';

export const RentalGrowthTopRentalMarketsWebApiHandler_topMarkets = (
  postData: GetTopRentalMarketsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetTopRentalMarketsRequestDto, GetTopRentalMarketsResponseDto>(
    {
      endpoint: RentalGrowthTopRentalMarketsWebApiHandler_topMarkets_Path,
      method: 'POST',
      contextPath: '/rental-growth-api',
      postData: postData,
    },
    client,
  );
};
